import { createContext, useContext, useMemo, useState } from 'react'

interface ListNameContextValue {
  listName: string
  setListName: React.Dispatch<React.SetStateAction<string>>
}

const ListNameContext = createContext<ListNameContextValue>(
  {} as ListNameContextValue
)

export const ListNameProvider = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  const [listName, setListName] = useState<string>('')

  const memoizedListName = useMemo(() => listName, [listName])
  const memoizedSetListName = useMemo(() => setListName, [setListName])

  return (
    <ListNameContext.Provider
      value={{ listName: memoizedListName, setListName: memoizedSetListName }}
    >
      {children}
    </ListNameContext.Provider>
  )
}

export const useListNameContext = () => {
  return useContext(ListNameContext)
}
